import React from 'react';
import ContentLoader from 'react-content-loader'




const SummaryBlockLoader = (props) => {

	return (
		<ContentLoader preserveAspectRatio="none" height="40">
			<rect x="20" y="5" width="70" height="5"></rect><rect x="20" y="15" width="40" height="2"></rect><rect x="105" y="5" width="70" height="5"></rect><rect x="105" y="15" width="40" height="2"></rect><rect x="105" y="20" width="40" height="2"></rect><rect x="190" y="5" width="40" height="5"></rect><rect x="190" y="15" width="40" height="2"></rect><rect x="235" y="5" width="40" height="5"></rect><rect x="235" y="15" width="40" height="2"></rect><rect x="290" y="5" width="70" height="5"></rect><rect x="290" y="15" width="30" height="2"></rect><rect x="340" y="15" width="30" height="2"></rect>

		</ContentLoader>
	)
}

export default SummaryBlockLoader;